import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BuscarBitacora } from '../interfaces/beans.interface';

@Injectable({
    providedIn: 'root'
})
export class APIService {

  url = environment.url + '/api';

  constructor(private http: HttpClient) {}

  get() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json');

    return this.http.get(`${ this.url }/version`, { headers }).pipe( map( data => data));
  }

}
